const evidenciaPrefixPath = '/external/evidencna-aplikacia';
const ciselnikyPrefixPath = '/external/ciselniky';
const pripomienkyPrefixPath = '/external/sprava-pripomienok';
const elegislativaPrefixPath = '/internal/elegislativa';
const indexerPrefixPath = '/vyhladavanie';
const iamPrefixPath = process.env.REACT_APP_IAM_PREFIX_PATH;

export {
  evidenciaPrefixPath, ciselnikyPrefixPath, pripomienkyPrefixPath,
  elegislativaPrefixPath, indexerPrefixPath, iamPrefixPath,
};
